
import { IWorker, Worker } from '../../utils/Worker';
import { Action } from './Actions';

const LOAD_USERS = 'LOAD_USERS';
const HAS_ACCESS = 'HAS_ACCESS';
const SET_SELECTED_WORKSPACE = 'SET_SELECTED_WORKSPACE';

export interface User {
  agent_id: string;
  created_on: string | null;
  departments: number[];
  email: string;
  full_name: string;
  phone: string;
  source_type: string | null;
  user_type: string | null;
  token: string;
  uid: number;
  source: IWorker;
}

export type WorkspaceAccess = {
  hasAccess: boolean;
  workspaces: User[];
}

const initialState: WorkspacesState = {
  users: [],
  hasAccess: false,
  selectedWorkspace: null,
}

export interface WorkspacesState {
  users: User[];
  hasAccess: boolean;
  selectedWorkspace: User | null;
}

export class WorkspaceActions {
  static loadUsers = (users: User[]): Action => ({ type: LOAD_USERS, payload: { users } })
  static setAccess = (hasAccess: boolean): Action => ({ type: HAS_ACCESS, payload: { hasAccess } })
  static setSelectedWorkspace = (selectedWorkspace: User | null): Action => ({ type: SET_SELECTED_WORKSPACE, payload: { selectedWorkspace } })
}

export function reduce(state: WorkspacesState = initialState, action: Action) {
  switch (action.type) {

    case HAS_ACCESS: {
      return {
        ...state,
        hasAccess: action.payload.hasAccess
      }
    }

    case LOAD_USERS: {
      return {
        ...state,
        users: action.payload.users.map((user: User) => ({
          ...user,
          source: new Worker(user.source)
        }))
      }
    }

    case SET_SELECTED_WORKSPACE: {
      return {
        ...state,
        selectedWorkspace: action.payload.selectedWorkspace
      }
    }

    default:
      return state;
  }
}

